import React from 'react';

import {ImputStyle} from './styles'

type Props = {
    showDisabled?: boolean,
} & React.ComponentPropsWithoutRef<'input'>;

const InputText = ({...props}: Props, ref: React.Ref<HTMLInputElement>) => {
    return (
        <div>
            <ImputStyle {...props} disabled={props.showDisabled}/>
        </div>
    );
};

InputText.defaultProps = {
    ShowDisabled: 'false',
}

export default InputText;
